import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  restaurantUuid: string;
  backTarget: string;
  backLabel: string;
}

/**
 * Écran servi quand le suivi de commande répond 401/403 : le jeton d'accès
 * n'est plus valable (lien rouvert sans sa query string, ou depuis un autre
 * appareil que celui qui a commandé — le jeton est par navigateur).
 * Distinct de NotFoundPage, qui reste la réponse au 404 « cette commande
 * n'existe pas » : le client doit savoir laquelle des deux il vit, et par où
 * sortir. `/account/orders` marche dans les deux cas — AccountGuard ouvre la
 * fenêtre de connexion et revient ici si la session manque.
 */
export default function TrackingLinkExpired({ restaurantUuid, backTarget, backLabel }: Props) {
  const { t } = useTranslation();
  return (
    <div className="max-w-[680px] mx-auto px-4 py-12 space-y-6" data-testid="tracking-link-expired">
      <div className="border-2 border-ink bg-paper p-6 shadow-stamp text-center space-y-3">
        <h1 className="font-display text-2xl text-ink">{t('confirmation.expired.title')}</h1>
        <p className="font-mono text-sm text-ink/80">{t('confirmation.expired.body')}</p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to={`/${restaurantUuid}/account/orders`}
          className="bg-mint border-2 border-ink rounded-btn px-6 py-3 font-display text-center shadow-stamp-sm"
        >
          {t('confirmation.expired.myOrders')}
        </Link>
        <Link
          to={backTarget}
          className="bg-paper border-2 border-ink rounded-btn px-6 py-3 font-display text-center"
        >
          {backLabel}
        </Link>
      </div>
    </div>
  );
}
